import { Component, Input, OnInit } from '@angular/core';
import { FormatCell, TableCell } from 'src/app/models/table';
import { mobileIcons, mobileLabels } from 'src/app/models/statistics';

@Component({
  selector: 'app-user-stats-table-row',
  templateUrl: './user-stats-table-row.component.html',
  styleUrls: ['./user-stats-table-row.component.scss'],
})
export class UserStatsTableRowComponent implements OnInit {
  @Input() nDataCells: number;
  @Input() formatLabel: string;
  @Input() formatIcon: string;
  @Input() data: string[];
  @Input() isTotalSection = false;
  @Input() isEndRow = false;

  dataCells: TableCell[] = [];
  formatCell: FormatCell;

  constructor() {}

  ngOnInit() {
    this.fillCells();
  }

  private fillCells() {
    const mobileIconsOffset = this.nDataCells - mobileIcons.length;
    const mobileLabelsOffset = this.nDataCells - mobileLabels.length;
    const dataOffset = this.nDataCells - this.data.length;
    this.formatCell = {
      formatIcon: this.formatIcon,
      formatLabel: this.formatLabel,
    };
    for (let i = 0; i < this.nDataCells; i++) {
      const cell: TableCell = {
        icon: i - mobileIconsOffset < 0 ? null : mobileIcons[i - mobileIconsOffset],
        label: i - mobileLabelsOffset < 0 ? null : mobileLabels[i - mobileIconsOffset],
        data: i - dataOffset < 0 ? null : this.data[i - dataOffset],
      };
      this.dataCells.push(cell);
    }
  }
}
